const gender = {
  MEN: 'M',
  FEMALE: 'F',
  X: 'X',
};

const missingStatus = {
  missing: 1,
  missingClose: 2,
};

const bsStatusP = {
  OCCUPIED: 'O',
  DISCHARGING: 'OD',
  TBC: 'TBC',
  AVAILABLE: 'A',
  UNAVAILABLE: 'U',
};

const uiStatus = {
  ...bsStatusP,
  MISSING: 'Missing',
  MISSING_CLOSED: 'Missing(closed case)',
};

const bookStatus = {
  OUTSTANDING: 'O',
  COMPLETED: 'C',
  DELETED: 'D',
  PENDINGFYA: 'PFYA',
  PENDING: 'P',
  ACCEPTED: 'A',
  DECLINED: 'DL',
};
const bedP = {
  admDtm: 'admDtm',
  gender: 'patGender',
  status: 'status',
  patientID: 'caseNo',
  age_patDob: 'patDob',
  currentWard_admDtm: 'admDtm',
  bedNo: 'bedNo',
  airbornePrecaution: 'airbornePrecautionYn',
  dropletPrecaution: 'dropletPrecautionYn',
  contactPrecaution: 'contactPrecautionYn',
  reverseLsolation: 'reversePrecautionYn',
  attention: 'attention',
  missing: 'missingYn',
  missingStatus: 'missingStatus',
  missingCaseCloseTime: 'missingCaseCloseTime',
  age: 'age',
  totalDats: 'wardBdo',
  isolationPrecaution: 'isolationPrecaution',
  dischargeDestination: 'dischgDest',
  NEATSBooking: 'ntssCreateDtm',
  maintenance: 'maintenanceYn',
  resuscitation: 'resuscitationYn',
  lifeSavingEquipment: 'lifeSavingEquipYn',
  bedCleaning: 'cleaning',
  forClinicalAdmission: 'pendingAdmission',
  lastUpdatedDate: 'lastUpdatedDate',
  bedType: 'bedType',
  currentDischgPatTranId: 'currentDischgPatTranId',
  ntssCreateDtm: 'ntssCreateDtm',
  covidPositivePat: 'covidPositivePat',
  homeLeaveDtm: 'homeLeaveDtm',
  homeLeaveType: 'homeLeaveType',
  remark: 'remark',
  ccWardCd: 'wardCd',
  transferInRequestInfo: 'transferInRequestInfo',
  transferOutRequestInfo: 'transferOutRequestInfo',
  returnDayCase: 'returnDayCase',
  frozenYn: 'frozenYn',
  mdroInfo: 'mdroInfos',
  proceedCleansing: 'proceedCleansing',
  elderlyHome: 'ehAddrInfo',
  cmsAlertInfos: 'cmsAlertInfos',
};

const uiRemarks = {
  DAY_BED: 'Day bed',
  ADDED_BED: 'Added bed',
  NEATS: 'NEATS',
  BASIC_CLEANSING: 'Basic cleansing',
  BASIC_CLEANSING_ONGOING: 'Basic cleansing(on going)',
  TERMINAL_DISINFECTION: 'Terminal disinfection',
  TERMINAL_DISINFECTION_ONGOING: 'Terminal disinfection(on going)',
  PENDING_ADMISSION: 'Pending admission',
  RESUSITATION: 'Resuscitation',
  MAINTANIENCE: 'Maintenance',
  AIRBORNE_PRECAUTION: 'Airborne precaution',
  DROPLET_PRECAUTION: 'Droplet precaution',
  CONTACT_PRECAUTION: 'Contact precaution',
  ATTENTION: 'Attention',
  REVERSE_LSOLATION: 'Reverse lsolation',
  COVID_19: 'Covid-19',
  HOME_LEAVE: 'Home Leave',
  HOME_LEAVE_OVERTIME: 'Home Leave(Overtime)',
  LIFE_SAVING_EQUIPMENT: 'Life-saving equipment',
  TO: 'TO',
  RETURN_DAY_CASE: 'Return day case',
  FROZEN: 'Frozen',
  MDRO_CONTACT: 'Mdro',
  MDRO_CONFIRMED: 'Mdro confirmed',
  CMS_ALERT: 'CMS Alert',
  ELDERLY_HOME: 'Elderly Home',
};

const bsRemarks = {
  ...uiRemarks,
  MISSING: 'Missing',
  MISSING_CLOSED: 'Missing(closed case)',
};

const remarkType = {
  occupieddischarge: 1,
  tbcAvailable: 2,
  available: 3,
};

const bsApp = { ...gender, ...uiStatus, ...uiRemarks, ...bookStatus };
const filterOption = [
  [bsApp.AVAILABLE, bsApp.OCCUPIED, bsApp.DISCHARGING, bsApp.TBC, bsApp.UNAVAILABLE],
  [
    bsApp.MISSING,
    bsApp.MISSING_CLOSED,
    bsApp.ATTENTION,
    bsApp.AIRBORNE_PRECAUTION,
    bsApp.DROPLET_PRECAUTION,
    bsApp.CONTACT_PRECAUTION,
    bsApp.REVERSE_LSOLATION,
    bsApp.COVID_19,
    bsApp.MDRO_CONTACT,
    bsApp.MDRO_CONFIRMED,
    bsApp.CMS_ALERT,
    bsApp.HOME_LEAVE,
    bsApp.HOME_LEAVE_OVERTIME,
    bsApp.TO,
  ],
  [bsApp.NEATS, bsApp.BASIC_CLEANSING, bsApp.TERMINAL_DISINFECTION, bsApp.PENDING_ADMISSION, bsApp.RETURN_DAY_CASE],
  [
    bsApp.DAY_BED,
    bsApp.ADDED_BED,
    bsApp.RESUSITATION,
    bsApp.MAINTANIENCE,
    bsApp.LIFE_SAVING_EQUIPMENT,
    bsApp.FROZEN,
    bsApp.ELDERLY_HOME,
  ],
];

const splitCode_blank = '\u2002';
const join_remarks_attention = ',';
export default bsApp;
export {
  bedP,
  uiRemarks as remarkP,
  remarkType,
  missingStatus,
  uiStatus as statusP,
  gender as genderP,
  bsStatusP,
  bsRemarks,
  filterOption,
  splitCode_blank,
  join_remarks_attention,
};
